@switch (currentLanguage()) {
  @case ('ru') {
    <app-rules-ru />
  }
  @default {
    <app-rules-en />
  }
}
